module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/pre2"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/pre3"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap1"
    }
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("1")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DICT OF")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILAN")]), _vm._v(" (313)")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap1"
    }
  }, [_vm._v("“No one whatsoever should be denied the opportunity to give his heart to the observance of the Christian religion.”")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("2")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICENE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REED")]), _vm._v(" (325)")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Light from Light, true God from true God, begotten not made, of one substance with the Father.”")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3 "), _c('i', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULE OF")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AINT")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENEDICT")])]), _vm._v(" (C. 530)")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“And so we are going to establish a school for the service of the Lord.”")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4 T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XCOMMUNICATION OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATRIARCH")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERULARIOS BY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EO")]), _vm._v(" IX "), _c('span', {
    staticClass: "small"
  }, [_vm._v("VIA")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARDINAL")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UMBERT")]), _vm._v(" (1054)")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“We have sensed here both a great good, whence we greatly rejoice in the Lord, and the greatest evil, whence we lament in misery.”")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5 M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTIN")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("LUTHER’S")]), _vm._v(" "), _c('i', [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INETY")]), _vm._v("-F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HESES")])]), _vm._v(" (1517)")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“When our Lord and Master Jesus Christ said, ʻRepent,ʼ he willed the entire life of believers to be one of repentance.”")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6 T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DINBURGH")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONFERENCE")]), _vm._v(" (1910)")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“The church is confronted today, as in no preceding generation, with a literally worldwide opportunity to make Christ known.”")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7 T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECOND")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATICAN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNCIL")]), _vm._v(" (1962–1965)")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Hence this Second Vatican Council, having probed more profoundly into the mystery of the Church, now addresses itself without hesitation, not only to the sons of the Church and to all who invoke the name of Christ, but to the whole of humanity.”")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General Index")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture Index")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("Christian History in Seven Sentences")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appen10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45ad39d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/sommaire.vue
// module id = 66
// module chunks = 0